export default function PHP_strcspn() {
  return (
    <div>
      <h1>PHP_strcspn</h1>
    </div>
  );
}
